import React from 'react';

import useIGTranslation from 'hooks/useIGTranslation';
import { dateTimeUtilities } from 'utilities/dateTimeUtilities';

import './LandingViewHeader.scss';

interface ILandingViewHeaderProps {
  openDate: number | undefined;
}

const LandingViewHeader = ({ openDate }: ILandingViewHeaderProps) => {
  const { t } = useIGTranslation();
  if (!openDate || openDate === 0) return null;
  const newOpenDate = new Date(openDate);
  let { weekday, day, month, ordinalSuffix } = dateTimeUtilities.formatDate(newOpenDate, t);
  const isNL = process.env.REACT_APP_LANGUAGE === 'nl';

  if (isNL && month === 'mei') {
    month = month.charAt(0).toUpperCase() + month.slice(1);
  }

  return (
    <div className="landing-header">
      <div className="landing-header__free-to-play-svg"></div>
      <div className="landing-header__coming-soon">{t('new-round-coming-soon')}</div>
      <div className="landing-header__date">
        {weekday} {day}
        {!isNL && <sup>{ordinalSuffix}</sup>} {month}
      </div>
    </div>
  );
};

export default LandingViewHeader;
